// <fiee-carousel>: carrusel de presentaciones del inicio del kiosco.
export class Carousel extends HTMLElement {
    private slides: HTMLElement[];
    private dots: HTMLElement[];
    private currentIndex: number = 0;
    private interval: number | null = null;
    private autoplay: boolean;
    private intervalMs: number;

    constructor() {
        super();
        this.autoplay = this.hasAttribute('data-autoplay') && this.getAttribute('data-autoplay') !== 'false';
        this.intervalMs = parseInt(this.getAttribute('data-interval') || '10000', 10);
        this.slides = [];
        this.dots = [];
    }

    connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.panel-carousel__slide'));
        this.dots = Array.from(this.querySelectorAll('.panel-carousel__dot'));

        if (this.slides.length === 0) return;

        // Una imagen que no carga (archivo borrado, disco lleno) deja ver la
        // portada de texto que hay debajo, en vez de un hueco negro.
        this.slides.forEach((slide) => {
            const img = slide.querySelector<HTMLImageElement>(':scope > img');
            if (!img) return;
            const broken = () => slide.classList.add('is-broken');
            if (img.complete && img.naturalWidth === 0) broken();
            else img.addEventListener('error', broken, { once: true });
        });

        // Mostrar la primera diapositiva
        this.goTo(0);

        // Botones de navegación
        const prevBtn = this.querySelector('.panel-carousel__arrow--prev');
        const nextBtn = this.querySelector('.panel-carousel__arrow--next');

        prevBtn?.addEventListener('click', () => this.prev());
        nextBtn?.addEventListener('click', () => this.next());

        // Puntos
        this.dots.forEach((dot, index) => {
            dot.addEventListener('click', () => this.goTo(index));
        });

        if (this.autoplay) {
            this.startAutoplay();
        }

        // Pausar mientras un ratón está encima. Sólo el ratón: en la pantalla
        // táctil un toque emula también mouseenter, y como no hay mouseleave
        // hasta tocar otra cosa, el carrusel se quedaba detenido para siempre.
        // Al tocar, las flechas y los puntos ya reinician el temporizador.
        this.addEventListener('pointerenter', (e) => {
            if (e.pointerType === 'mouse') this.stopAutoplay();
        });
        this.addEventListener('pointerleave', (e) => {
            if (e.pointerType === 'mouse') this.startAutoplay();
        });
    }

    disconnectedCallback() {
        this.stopAutoplay();
    }

    goTo(index: number) {
        if (index < 0 || index >= this.slides.length) return;
        this.currentIndex = index;

        // Quitar la clase 'is-active' de todas las diapositivas
        this.slides.forEach((slide) => {
            slide.classList.remove('is-active');
        });

        // Añadir la clase 'is-active' a la diapositiva actual
        this.slides[index]?.classList.add('is-active');

        // Actualizar puntos
        this.dots.forEach((dot, i) => {
            if (i === index) {
                dot.classList.add('is-active');
            } else {
                dot.classList.remove('is-active');
            }
        });
    }

    prev() {
        const newIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
        this.goTo(newIndex);
        this.resetAutoplay();
    }

    next() {
        const newIndex = (this.currentIndex + 1) % this.slides.length;
        this.goTo(newIndex);
        this.resetAutoplay();
    }

    startAutoplay() {
        if (!this.autoplay) return;
        if (this.interval) return;
        this.interval = window.setInterval(() => this.next(), this.intervalMs);
    }

    stopAutoplay() {
        if (this.interval) {
            window.clearInterval(this.interval);
            this.interval = null;
        }
    }

    resetAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
    }
}
